/**
 * API is responsible to all logic related to endpoints.
 * It is responsible to get errors returned from endpoints in different formats and throw a single error message.
 * TODO: throw an object with message and optionally a code or other relevant information.
 */
import axios from "axios";
import { fullAPIURL } from "../utils/requests";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";

// custom axios
const locationAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/calendar/`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

locationAxios.interceptors.request.use(requestAccessTokenInterceptor);

locationAxios.interceptors.response.use(responseStatusInterceptor);

// endpoints

export interface UpdateLocationPayload {
  uuid: string;
  name: string;
  isVirtual: boolean;
  linkName: string;
  linkUrl: string;
}

export async function updateLocation(payload: UpdateLocationPayload) {
  const url = `/location/${payload.uuid}`;
  const response = await locationAxios.patch<void>(url, {
    name: payload.name,
    linkName: payload.linkName,
    linkUrl: payload.linkUrl,
    isActive: true,
    hasLink: true,
    isVirtualLocation: payload.isVirtual,
  });
  return response.data;
}

export interface CreateLocationPayload {
  name: string;
  isVirtual: boolean;
  linkName: string;
  linkUrl: string;
}

export async function createLocation(payload: CreateLocationPayload) {
  const url = "/location";
  const response = await locationAxios.post<void>(url, {
    name: payload.name,
    linkName: payload.linkName,
    linkUrl: payload.linkUrl,
    isActive: true,
    hasLink: true,
    isVirtualLocation: payload.isVirtual,
  });
  return response.data;
}

export async function deleteLocation(locationUuid: string) {
  const url = `/location/${locationUuid}`;
  const response = await locationAxios.delete<void>(url);
  return response.data;
}
